import React from "react";
import {
  VictoryBar,
  VictoryChart,
  VictoryAxis,
  VictoryLabel,
  VictoryGroup,
} from "victory";

export default function HorizontalBarChart(props) {
  const { data, colors } = props;

  var barcount = 0;
  data.map(() => {
    barcount++;
  });

  return (
    <div>
      <VictoryChart
        horizontal
        padding={{ left: 0, top: 20, bottom: 20, right: 50 }}
        height={barcount * 42}
      >
        <VictoryGroup colorScale={colors}>
          {data.map((d, i) => {
            return (
              <VictoryBar
                key={i}
                data={[d]}
                alignment="middle"
                labels={[`${d.y}%`]}
                labelComponent={
                  <VictoryLabel
                    style={[{ fill: "black" }]}
                    verticalAnchor={"middle"}
                    dy={1}
                  />
                }
                barWidth={35}
                cornerRadius={{
                  topLeft: 10,
                  topRight: 10,
                  bottomLeft: 10,
                  bottomRight: 10,
                }}
              />
            );
          })}
        </VictoryGroup>
        <VictoryAxis
          crossAxis={false}
          orientation="left"
          style={{
            tickLabels: {
              padding: -10,
              textAnchor: "start",
              fontSize: 13,
              fill: (datum) => {
                return datum.tickValue >= datum.ticks.length - 1
                  ? "white"
                  : "black";
              },
            },
            axis: { stroke: "none" },
          }}
        />
      </VictoryChart>
    </div>
  );
}
